import { ConfigType } from '../utils/requestAPI';

type GetAllJobsParamsType = {
  page?: number;
  limit?: number;
};

type GetAcceptedContractType = {
  page?: number;
  limit?: number;
};
type MyParams = {
  page?: number;
  limit?: number;
  search?: string;
};

export type sendPdfDataType = {
  pdf: {
    title: string;
    url: string;
  }[];
  pdfNotes: string[];
  jobAndProposalId: string;
};

type ReviewDataType = {
  review: string[];
  reviewId: string;
  reviewStatus: 'ACCEPT' | 'REJECT';
  jobProcessId?: string;
};
type AssignReviewType = {
  assigneeUserId: string;

  reviewId: string;

  jobProcessId: string;
};
const jobsApi = {
  // JOBS
  getAllJobs: (params: GetAllJobsParamsType): ConfigType => {
    return {
      url: '/jobs/technician/acceptedTechnicianJobs',
      method: 'get',
      params,
      config: { store: { action: 'set', key: '' } },
    };
  },

  getTechnicianJobsDetails: (jobId: string): ConfigType => {
    return {
      url: `/technician-jobs/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'technicianJobsDetails' } },
    };
  },

  // JOB AND PROPOSALS
  getJobAndProposalByJobId: (jobId: string): ConfigType => {
    return {
      url: `/job-proposal/job/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'jobAndProposal' } },
    };
  },
  getJobAndProposalById: (id: string): ConfigType => {
    return {
      url: `/job-proposal/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'jobAndProposal' } },
    };
  },

  // JOB PROCESS
  sendPdf: (data: sendPdfDataType): ConfigType => {
    return {
      url: '/job-process',
      method: 'post',
      data: data,
    };
  },
  getAllPDF: (): ConfigType => {
    return {
      url: '/job-process/all-pdf',
      method: 'get',
      config: {
        store: {
          action: 'set',
          key: 'getAllPDF.data',
        },
      },
    };
  },

  getAllJobReviews: (params: MyParams): ConfigType => {
    return {
      url: '/job-process/lists-review',
      params,
      method: 'get',
      config: { store: { action: 'set', key: 'pdfs.data' } },
    };
  },

  getJobProcessByClientId: (): ConfigType => {
    return {
      url: '/job-process/job-process-by-clientId',
      method: 'get',
      config: { store: { action: 'set', key: 'clientJobProcess.data' } },
    };
  },

  acceptReview: (data: ReviewDataType, id: string): ConfigType => {
    return {
      url: `/job-process/review-job-process/${id}`,
      method: 'post',
      data,
    };
  },
  reviewByClient: (data: ReviewDataType): ConfigType => {
    return {
      url: `/job-process/review-by-client`,
      method: 'post',
      data,
    };
  },
  sendForReview: (jobProcessId: string, reviewId: string): ConfigType => {
    return {
      url: `/job-process/send-to-review`,
      method: 'post',
      data: { jobProcessId, reviewId },
    };
  },
  sendTotClient: (jobProcessId: string, reviewId: string): ConfigType => {
    return {
      url: `/job-process/send-to-client`,
      method: 'post',
      data: { jobProcessId, reviewId },
    };
  },

  jobProcessReviewDetails: (id: string): ConfigType => {
    return {
      url: `/job-process/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'singleJobProcessReview' } },
    };
  },

  getJobProcessByJobProposal: (id: string): ConfigType => {
    return {
      url: `/job-process/job-and-proposal/${id}`,
      method: 'get',
      config: {
        store: {
          action: 'set',
          key: 'singleJobProcess',
        },
      },
    };
  },

  getJobProcessStatusByJobProposal: (id: string): ConfigType => {
    return {
      url: `/job-process/job-and-proposal/${id}/status`,
      method: 'get',
      config: {
        store: {
          action: 'set',
          key: 'singleJobProcessStatus',
        },
      },
    };
  },

  // CONTRACTS
  getAccepetedContractJobs: (params?: GetAcceptedContractType): ConfigType => {
    return {
      url: '/contracts/lists-accepted-jobs-by-technician',
      method: 'get',
      params,
      config: {
        store: {
          action: 'set',
          key: 'acceptedContractJobs.data',
        },
      },
    };
  },

  // PROPOSALS
  getProposalAtClientByJobId: (jobId: string): ConfigType => {
    return {
      url: `/proposals/job-detail/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'proposal' } },
    };
  },
  getProposalAtTechnicianByJobId: (jobId: string): ConfigType => {
    return {
      url: `/proposals/job/${jobId}`,
      method: 'get',
      config: { store: { action: 'set', key: 'proposal' } },
    };
  },
  assignReview: (data: AssignReviewType): ConfigType => {
    return {
      url: `/job-process/assign-review`,
      method: 'post',
      data,
    };
  },
};

export default jobsApi;
